export const isRowSelectable = (rowNode) => {
  if (!rowNode?.data) return false
  const { carrier_info, carrier_notify_state, state } = rowNode.data
  /**
   * This needs some serious refactoring and consolidation, but this condition serves as a mirror to the logic
   * for rendering the 'Send Order' button. Essentially, we only want to make a row selectable for multi-sending
   * if it meets the same requirements for sending individually. It might be easier in the future to have a flag
   * sent from the server 'can_send' that we can key off of for both.
   */
  return (
    state !== 'complete' &&
    state !== 'canceled' &&
    carrier_notify_state !== 'pending' &&
    !(carrier_notify_state === 'sent' && !carrier_info?.crossroads_status) &&
    (!carrier_info?.crossroads_status || ['rejected', 'error'].includes(carrier_info?.crossroads_status))
  )
}
